(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  define('pricelist/views/NodeView',["jquery", "backbone", "hbs!pricelist/templates/node", "hbs!pricelist/templates/node-formatted", "hbs!pricelist/templates/price", "hbs!pricelist/templates/format", "hbs!pricelist/templates/section-node"], function($, Backbone, nodeTemplate, nodeFormattedTemplate, priceTemplate, formatTemplate, sectionTemplate) {
    var View;
    return View = (function(superClass) {
      var counter;

      extend(View, superClass);

      function View() {
        this.render = bind(this.render, this);
        return View.__super__.constructor.apply(this, arguments);
      }

      View.prototype.tagName = "div";

      View.prototype.className = "node";

      View.prototype.initialize = function() {
        this.layout = this.options.layout;
        this.collapseCounter = this.options.collapseCounter;
        this.iabSizes = ["980 x 120", "980 x 240", "980 x 360", "50 x 120", "50 x 240", "50 x 280", "50 x 360", "50 x 480", "468 x 120", "468 x 240", "468 x 360", "468 x 480", "300 x 250", "320 x 50", "320 x 80", "320 x 160", "320 x 240", "320 x 320", "320 x 480", "728 x 90", "180 x 150", "160 x 600"];
        if (this.layout === "R" || this.layout === "r") {
          return this.template = priceTemplate;
        } else if (this.layout === "f") {
          return this.template = formatTemplate;
        } else if (this.options.wholeLayout.toLowerCase().indexOf("spv") > -1 && this.layout.toLowerCase() === "s") {
          return this.template = nodeFormattedTemplate;
        } else if (this.layout.toLowerCase() === "s" || this.layout.toLowerCase() === "p") {
          return this.template = sectionTemplate;
        } else {
          return this.template = nodeTemplate;
        }
      };

      counter = 0;

      View.prototype.render = function() {
        var i, iabSize, isIab, len, name, ref, res, size, sizePortion, tempModel;
        if (this.model == null) {
          return alert("Ett tekniskt fel förekom.");
        }
        if (this.layout === "f") {
          name = this.model.get("Name");
          res = name.match(/(.+)(\(.+\))$/);
        }
        if ((res != null ? res.length : void 0) === 3) {
          sizePortion = res[2].trim();
          isIab = false;
          ref = this.iabSizes;
          for (i = 0, len = ref.length; i < len; i++) {
            iabSize = ref[i];
            if (sizePortion.indexOf(iabSize) > 0) {
              size = iabSize;
              isIab = true;
              break;
            }
          }
          this.$el.addClass(this.nodeClass()).html(this.template({
            Name: res[1].trim(),
            Size: res[2].trim().replace("(", "").replace(")", "").replace("px", ""),
            IsIAB: isIab,
            IsPrint: this.options.isPrint,
            CollapseCounter: this.collapseCounter
          }));
        } else {
          tempModel = this.model.toJSON();
          tempModel.CollapseCounter = this.collapseCounter;
          this.$el.addClass(this.nodeClass()).html(this.template(tempModel));
        }
        this.$el.attr("title", this.nodeTitle());
        this.$el.find("div:first").attr("title", this.nodeTitle());
        if (this.layout === "V" && this.model.get("Name") === null) {
          this.$el.css({
            visibility: "hidden",
            height: 0
          });
        }
        return this;
      };

      View.prototype.nodeClass = function() {
        var classes;
        classes = (function() {
          switch (this.layout) {
            case "S":
            case "s":
              return "table-title";
            case "P":
            case "p":
              return "table-title";
            case "F":
            case "f":
              return "format";
            case "V":
            case "v":
              return "variant";
            case "I":
            case "i":
              return "weekday";
            case "C":
            case "c":
              return "comment";
            case "R":
            case "r":
              return "price color-" + this.model.get("Colors") + " color-padding-" + this.options.padding;
            default:
              return "";
          }
        }).call(this);
        if (this.layout.toLowerCase() === this.layout) {
          return classes += " flatten";
        } else {
          return classes += "";
        }
      };

      View.prototype.nodeTitle = function() {
        switch (this.layout) {
          case "S":
          case "s":
            return "Avdelning";
          case "P":
          case "p":
            return "Placering";
          case "F":
          case "f":
            return "Format";
          case "V":
          case "v":
            return "Prisvariant";
          case "I":
          case "i":
            return "Införandedag";
          case "C":
          case "c":
            return "Kommentar";
          case "R":
          case "r":
            return "Pris";
          default:
            return "";
        }
      };

      return View;

    })(Backbone.View);
  });

}).call(this);

//# sourceMappingURL=NodeView.js.map
;
